import alterReplace from '@/functions/alterStrReplace'
import makeScenarioFunc from '@/functions/makeScenarioFunc'
import moment from 'moment'
const watchScenarioMixin = {
  computed: {
    isInputBack() {
      let logs = this.chatTalkHistory.filter(obj => {
        return obj.speaker === 'other'
      })
      if (logs.length > 1) {
        // 選択肢、自由入力、チェックボックス、プルダウンパーツ、カルーセル、検索パーツかつ、前のシナリオと同一（間にロボ切り替えがない）場合はdisabledを外す
        return !(
          (logs[logs.length - 2].status === 0 ||
            logs[logs.length - 2].status === 6 ||
            logs[logs.length - 2].status === 13 ||
            logs[logs.length - 2].status === 15 ||
            logs[logs.length - 2].status === 17 ||
            logs[logs.length - 2].status === 20) &&
          logs[logs.length - 2].is_back &&
          logs[logs.length - 2].email === this.targetID &&
          logs[logs.length - 2].scenarioNode != this.scenario.select[0].next_node
        )
      } else {
        return true
      }
    },
  },
  methods: {
    isUserInJapan() {
      const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
      const timezoneOffset = new Date().getTimezoneOffset()
      
      return (
        userTimezone.includes('Asia/Tokyo') || 
        userTimezone.includes('Japan') || 
        timezoneOffset === -540
      )
    },
    backScenario() {
      let logs = this.chatTalkHistory.filter(obj => {
        return obj.speaker === 'other'
      })
      if (logs.length > 1) {
        if (logs[logs.length - 2].status === 0) {
          // スコアの減算
          let point = localStorage.getItem('SCR') ? Number(localStorage.getItem('SCR')) : 0
          let bkPoint = localStorage.getItem('BK_SCR') ? Number(localStorage.getItem('BK_SCR')) : 0
          point = Number(point) - Number(bkPoint)
          localStorage.setItem('SCR', point < 0 ? 0 : point)
        }
        this.$store.dispatch('chatbot/getScenarioOne', {
          companyid: this.data.ckey,
          scenarioName: this.chatTalkHistory[this.chatTalkHistory.length - 2].scenarioName,
          node: this.chatTalkHistory[this.chatTalkHistory.length - 2].scenarioNode,
          rate: this.color.thinking_rate,
          minipk: this.minipk,
        })
      }
    },
    getCalendar() {
      let param = this.$_.cloneDeep(this.scenario.parameter)
      // 開始日を計算
      let now = new Date()
      now = new Date(now.setSeconds(0))
      now = new Date(now.setHours(param.work_time_start))
      now = new Date(now.setMinutes(param.work_time_start * 100 - now.getHours() * 100))
      let nextDay = new Date(now.setDate(new Date().getDate() + param.after))
      // 当日の場合
      if (param.after != undefined) {
        if (param.after === 0) {
          nextDay = new Date(nextDay.setHours(new Date().getHours() + 3))
        }
      }
      param.after = nextDay.toLocaleString('ja-JP')
      const setItemName = 'CAL_' + (this.viewType === 0 ? this.botid : this.targetID)
      let scheduleData = localStorage.getItem(setItemName)
      if (scheduleData) {
        let parseData = JSON.parse(scheduleData)
        if (parseData.flg) {
          param.after = new Date(parseData.date).toLocaleString('ja-JP')
          parseData.flg = false
          localStorage.setItem(setItemName, JSON.stringify(parseData))
        }
      }
      this.$store.dispatch('calendar/getRecommendSchedule', param)
    },
    pushScenario() {
      let scenarioData = this.makeScenario()
      this.$store.dispatch('directtalk/pushChat', scenarioData)
      this.$store.dispatch('directtalk/createSeekerATHistory', {
        target: scenarioData.email,
        action: 'send_scn',
        url: this.data.url,
        element: this.scenario.beforenode,
      })
    },
    pushScenarioCalendar() {
      let scenarioData = this.makeScenarioCalendar()
      this.$store.dispatch('directtalk/pushChat', scenarioData)
      this.$store.dispatch('directtalk/createSeekerATHistory', {
        target: scenarioData.email,
        action: 'send_scn',
        url: this.data.url,
        element: this.scenario.beforenode,
      })
    },
    makeScenario() {
      let name = this.target
      let id = this.targetID
      let icon = this.targetIcon
      // 画像表示かイメージかで切り替える
      let msg = ''
      if (this.scenario.status == 5) {
        msg = '[msg][image]' + this.scenario.image + '[/image][/msg]|' + this.scenario.template
      } else if (this.scenario.status == 14) {
        msg = '[msg][movie]' + this.scenario.movie + '[/movie][/msg]' + this.scenario.template
      } else {
        msg = '[msg]' + this.scenario.mainmessage + '[/msg]|' + this.scenario.template
      }

      // メッセージ内容にロボ引用がある場合は置換する
      if (this.roboArguments) {
        for (const arg of this.roboArguments) {
          // 本文のロボ引用を置換
          msg = msg.replace(
            new RegExp(arg.key, 'g'),
            arg.value
          )
        }
      }
      // 置換できなかったロボ引用は削除
      msg = msg.replace(
        new RegExp(/__robo_quote\.([a-z0-9]+|[a-z]+)__/, 'g'),
        ''
      )

      // シナリオ送出
      let scenarioData = {
        message: msg,
        name: name,
        url: this.data.url,
        email: id,
        speaker: 'other',
        icon: icon,
        createdAt: new Date().toISOString(),
        sendToID: this.seeker.id,
        minibot_pk: this.minipk ? this.minipk : '',
        sendToModel: '',
        scenarioNode: this.scenario.beforenode,
        btnIdx: 0,
        isManager: '2',
        appname: '',
        platform: '',
        refferer: '',
        useragent: '',
        count: 0,
        status: this.scenario.status,
        parameter: this.scenario.parameter,
        quoteFlg: this.scenario.quote_flg,
        is_back: this.scenario.is_back,
        pk: this.scenario.pk,
      }
      const settingItems = {
        lsApplicant: localStorage.getItem('NM_' + this.seeker.id),
        lsEmail: localStorage.getItem('EM_' + this.seeker.id),
        lsTel: localStorage.getItem('TL_' + this.seeker.id),
        lsAddress: localStorage.getItem('AD_' + this.seeker.id),
        lsFurigana: localStorage.getItem('FR_' + this.seeker.id),
        lsYyyymmdd: localStorage.getItem('BD_' + this.seeker.id),
        lsYears: localStorage.getItem('YE_' + this.seeker.id),
        lsShikaku: localStorage.getItem('SH_' + this.seeker.id),
        lsCareer: localStorage.getItem('GK_' + this.seeker.id),
        lsBikou: localStorage.getItem('BK_' + this.seeker.id),
        lsSchedule: localStorage.getItem('SC_' + this.seeker.id),
        lsPoint: localStorage.getItem('SCR'),
      }
      let tempChatTalkHistory = this.chatTalkHistory.slice().reverse()
      return makeScenarioFunc.getScenarioData(
        this.$_.cloneDeep(scenarioData),
        { ...settingItems },
        this.$_.cloneDeep(tempChatTalkHistory),
        this.roboArguments
      )
    },
    makeScenarioCalendar() {
      let name = this.target
      let id = this.targetID
      let icon = this.targetIcon
      let templateDate = ''
      if (this.recommendDate.start !== 'Initialized') {
        const buttonTagS = '[button]'
        const buttonTagE = '[/button]'
        const pipe = '|'
        for (let i=0; i<this.recommendDate.length; i++) {
          const recDate =
            new Date(this.recommendDate[i].start).getMonth() +
            1 +
            '/' +
            new Date(this.recommendDate[i].start).getDate() +
            ' (' +
            this.weekday[new Date(this.recommendDate[i].start).getDay()] +
            ') ' +
            new Date(this.recommendDate[i].start).getHours() +
            ':' +
            ('00' + new Date(this.recommendDate[i].start).getMinutes()).slice(-2) +
            ' ~ ' +
            new Date(this.recommendDate[i].end).getHours() +
            ':' +
            ('00' + new Date(this.recommendDate[i].end).getMinutes()).slice(-2)
          templateDate += pipe + buttonTagS + recDate + buttonTagE
        }
      }

      // メッセージ内容にロボ引用がある場合は置換する
      let msg = '[msg]' + this.scenario.mainmessage + '[/msg]' + templateDate
      if (this.roboArguments) {
        for (const arg of this.roboArguments) {
          // 本文のロボ引用を置換
          msg = msg.replace(
            new RegExp(arg.key, 'g'),
            arg.value
          )
        }
      }
      // 置換できなかったロボ引用は削除
      msg = msg.replace(
        new RegExp(/__robo_quote\.([a-z0-9]+|[a-z]+)__/, 'g'),
        ''
      )

      let scenarioData = {
        message: msg,
        name: name,
        url: this.data.url,
        email: id,
        speaker: 'other',
        icon: icon,
        createdAt: new Date().toISOString(),
        sendToID: this.seeker.id,
        minibot_pk: this.minipk ? this.minipk : '',
        sendToModel: '',
        scenarioNode: this.scenario.beforenode,
        btnIdx: 0,
        isManager: '2',
        appname: '',
        platform: '',
        refferer: '',
        useragent: '',
        count: 0,
        status: this.scenario.status,
        parameter: this.scenario.parameter,
      }
      return scenarioData
    },
    convertScheduleMessageToJST(scheduleMessage) {
      // 日時文字列から日付と時間を抽出
      const match = scheduleMessage.match(/(\d+)\/(\d+)\s*\([月火水木金土日]\)\s*(\d+):(\d+)\s*~\s*(\d+):(\d+)/)
      
      if (match) {
        const month = parseInt(match[1]) - 1
        const day = parseInt(match[2])
        const startHour = parseInt(match[3])
        const startMinute = parseInt(match[4])
        const endHour = parseInt(match[5])
        const endMinute = parseInt(match[6])
        
        const currentYear = new Date().getFullYear()
        
        // ローカルタイムゾーンの日時オブジェクトを作成
        const localStartDate = new Date(currentYear, month, day, startHour, startMinute)
        const localEndDate = new Date(currentYear, month, day, endHour, endMinute)
        
        // ローカルタイムゾーンから日本時間への直接変換
        const localOffset = localStartDate.getTimezoneOffset() * 60000 // ローカルオフセット（ミリ秒）
        const jstStartTime = localStartDate.getTime() + localOffset + (9 * 60 * 60 * 1000)
        const jstEndTime = localEndDate.getTime() + localOffset + (9 * 60 * 60 * 1000)
        
        const jstStartDate = new Date(jstStartTime)
        const jstEndDate = new Date(jstEndTime)
        
        // 日本時間で日時文字列を再構築
        const weekday = ['日', '月', '火', '水', '木', '金', '土']
        
        return (jstStartDate.getMonth() + 1) + '/' +
               jstStartDate.getDate() +
               ' (' + weekday[jstStartDate.getDay()] + ') ' +
               jstStartDate.getHours() + ':' +
               ('00' + jstStartDate.getMinutes()).slice(-2) +
               ' ~ ' +
               jstEndDate.getHours() + ':' +
               ('00' + jstEndDate.getMinutes()).slice(-2)
      }
      
      return scheduleMessage
    },
    async createNewSessionFromBranch(patternIndex) {
      // デモ環境または seeker が存在しない場合の保護
      if (this.isDemo || !this.seeker) {
        console.warn('セッション切替: デモ環境または seeker が存在しないため処理をスキップ')
        return
      }
      
      // 既にセッション切替処理中の場合はスキップ
      if (this.isSessionSwitching) {
        console.log('Session switch already in progress, skipping...')
        return
      }
      
      try {
        // セッション切替処理中フラグを立てる
        this.isSessionSwitching = true
        
        // ローディング表示（管理画面のみ）
        if (this.viewType === 1) {
          this.$store.commit('common/setLoading', true)
        }
        
        // セッションIDの取得（複数の方法を試行）
        let sessionId = null
        
        // 1. seekerオブジェクトから取得を試行
        // 優先順位: sessionid > id
        if (this.seeker) {
          if (this.seeker.sessionid) {
            sessionId = this.seeker.sessionid
          } else if (this.seeker.id) {
            sessionId = this.seeker.id
          }
        }
        
        // 2. LocalStorageから取得を試行
        if (!sessionId && localStorage.getItem('sessionid')) {
          sessionId = localStorage.getItem('sessionid')
        }
        
        // 3. storeから取得を試行
        if (!sessionId) {
          if (this.$store.state.directtalk.sessionId) {
            sessionId = this.$store.state.directtalk.sessionId
          } else if (this.$store.state.directtalk.seeker && this.$store.state.directtalk.seeker.id) {
            sessionId = this.$store.state.directtalk.seeker.id
          }
        }
        
        // セッションIDが取得できない場合はエラー
        if (!sessionId) {
          console.error('Session ID not found')
          console.error('Seeker object:', this.seeker)
          console.error('LocalStorage sessionid:', localStorage.getItem('sessionid'))
          console.error('Store directtalk.sessionId:', this.$store.state.directtalk.sessionId)
          throw new Error('セッションIDが見つかりません。ページを再読み込みしてください。')
        }
        
        // デバッグログ（開発環境のみ）
        if (process.env.NODE_ENV === 'development') {
          console.log('Session switch initiated:', {
            sessionId: sessionId,
            scenarioId: this.scenario.pk,
            patternIndex: patternIndex,
            scenario: this.scenario,
            parameter: this.scenario && this.scenario.parameter,
            parameterAtIndex: this.scenario && this.scenario.parameter && this.scenario.parameter[patternIndex],
            select: this.scenario && this.scenario.select,
            selectAtIndex: this.scenario && this.scenario.select && this.scenario.select[patternIndex]
          })
        }
        
        // 新規セッション作成APIを呼び出し
        const response = await this.$store.dispatch('directtalk/createNewSession', {
          old_session_id: sessionId,  // 修正: seeker.idではなくsessionidを使用
          reason: 'セッション切替分岐パーツによる切り替え',
          scenario_id: this.scenario ? this.scenario.pk : null,
          pattern_index: patternIndex,
          // 重要: next_node情報を追加
          // 条件分岐パーツではnext_nodeはselect配列にある
          next_node: (this.scenario && this.scenario.select && this.scenario.select[patternIndex] && this.scenario.select[patternIndex].next_node) || null,
          scenario_name: (this.scenario && this.scenario.name) || null,
          inherit_data: {
            // 必要に応じて継承するデータを追加
            url: (this.seeker && this.seeker.url) || '',
            referrer: (this.seeker && this.seeker.refferer) || ''
          }
        })
        
        if (response && response.status === 'success') {
          // LocalStorageの更新
          const newSessionId = response.new_session_id
          localStorage.setItem('sessionid', newSessionId)
          
          // 訪問時刻を記録
          localStorage.setItem(`last_visit_${newSessionId}`, Date.now().toString())
          
          // Storeの更新
          this.$store.commit('directtalk/SET_SESSION_ID', newSessionId)
          
          // 重要: Vuexストアのseeker情報を完全に更新
          this.$store.commit('directtalk/SET_SEEKER_INFO', {
            id: response.sessionid || newSessionId,  // sessionidをidに設定
            pk: response.id,
            sessionid: newSessionId,
            name: response.seeker_name || '訪問者',
            group: this.data.ckey,
            count: 1
          })
          
          // ローカルのthis.seekerは計算プロパティの可能性があるため、
          // Vuexストアの更新のみで対応（上記のSET_SEEKER_INFOで十分）
          
          // WebSocket再接続（ウィジェットの場合のみ）
          if (this.viewType === 0) {
            try {
              // 1. 既存のWebSocket接続をクローズ
              if (this.$store.state.directtalk.ws) {
                this.$store.state.directtalk.ws.close()
              }
              
              // 2. Room情報の取得を待つ（エラーハンドリング強化）
              try {
                await this.$store.dispatch('directtalk/getRoom')
                
                // Room情報が正しく取得できたか確認
                if (!this.$store.state.directtalk.widgetData || 
                    !this.$store.state.directtalk.widgetData.roomPK) {
                  throw new Error('Room情報の取得に失敗しました')
                }
              } catch (roomError) {
                console.error('Room情報取得エラー:', roomError)
                // 再試行処理
                if (!this.retryCount) this.retryCount = 0
                if (this.retryCount < 3) {
                  this.retryCount++
                  await new Promise(resolve => setTimeout(resolve, 1000))
                  return this.createNewSessionFromBranch(patternIndex) // 再試行
                }
                throw roomError
              }
              
              // 3. 少し待機（Room情報の反映を確実にするため）
              await new Promise(resolve => setTimeout(resolve, 300))
              
              // 4. WebSocket URLを生成（ChatWidgetDialog.vueと同じパターン）
              // 重要: WS_ENDPOINTには既に'/ws/chat/'が含まれている
              const wsUrl = process.env.WS_ENDPOINT + this.data.ckey + '/' + newSessionId + '/'
              
              // 5. デバッグログ（開発環境のみ）
              if (process.env.NODE_ENV === 'development') {
                console.group('Session Switch Debug Info')
                console.log('Old Session ID:', sessionId)
                console.log('New Session ID:', newSessionId)
                console.log('Seeker Info:', this.seeker)
                console.log('Store Seeker:', this.$store.state.directtalk.seeker)
                console.log('Room Info:', this.$store.state.directtalk.widgetData)
                console.log('WebSocket URL:', wsUrl)
                console.log('Next Node:', (this.scenario && this.scenario.parameter && this.scenario.parameter[patternIndex] && this.scenario.parameter[patternIndex].next_node) || null)
                console.groupEnd()
              }
              
              // 6. WebSocket再接続
              await this.$store.dispatch('directtalk/connect', { 
                uri: wsUrl, 
                category: 'widget' 
              })
              
              // 7. WebSocket接続の確立を待つ（より長い待機時間）
              await new Promise(resolve => setTimeout(resolve, 1500))
              
              // WebSocket接続状態を確認
              if (!this.$store.state.directtalk.isConnectRoom) {
                console.warn('WebSocket not connected yet, waiting more...')
                await new Promise(resolve => setTimeout(resolve, 1000))
              }
              
              // 8. 次のノードへ進む処理
              // セッション切替時はnext_node情報をLocalStorageに保存
              const tempTid = this.minipk || (this.viewType === 0 ? this.botid : this.targetID)
              const nextNode = response.next_node || (this.scenario && this.scenario.select && this.scenario.select[patternIndex] && this.scenario.select[patternIndex].next_node)
              
              if (nextNode) {
                // デバッグ用ログ
                console.log('セッション切替後のnext_node:', nextNode)
                console.log('response:', response)
                
                // セッション切替の場合は、LocalStorageへの保存をスキップ
                // これにより「続きから再開しますか？」画面を回避
                
                // 「続きから始める」画面を回避するため、lastViewをnullに設定
                this.$store.commit('chatbot/SET_LAST_VIEW', null)
                
                // 既存のscenariolvを削除（存在する場合）
                const scenarioKey = 'scenariolv_' + tempTid
                if (localStorage.getItem(scenarioKey)) {
                  localStorage.removeItem(scenarioKey)
                }
                
                // 少し待機してから次のシナリオを取得（UIの更新を確実にするため）
                await new Promise(resolve => setTimeout(resolve, 100))
                
                // セッション切替中フラグをセッションストレージに保存（一時的）
                sessionStorage.setItem('isSessionSwitching', 'true')
                
                // lastViewをnullにして「続きから再開しますか？」を表示させない
                this.$store.commit('chatbot/SET_LAST_VIEW', null)
                
                // 直接次のシナリオを取得
                console.log('Calling getScenarioOne with:', {
                  companyid: this.data.ckey,
                  scenarioName: response.scenario_name || this.scenario.name,
                  node: nextNode,
                  rate: this.color.thinking_rate,
                  minipk: this.minipk,
                })
                
                // 少し待機してシナリオを取得
                await new Promise(resolve => setTimeout(resolve, 200))
                
                this.$store.dispatch('chatbot/getScenarioOne', {
                  companyid: this.data.ckey,
                  scenarioName: response.scenario_name || this.scenario.name,
                  node: nextNode,
                  rate: this.color.thinking_rate,
                  minipk: this.minipk,
                })
                
                // フラグをクリア（3秒後）
                setTimeout(() => {
                  sessionStorage.removeItem('isSessionSwitching')
                }, 3000)
              } else {
                console.warn('Next node not found in response or scenario')
              }
              
            } catch (error) {
              console.error('WebSocket再接続エラー:', error)
              // エラー時は再接続ダイアログを表示
              if (this.viewType === 0) {
                this.showReconnectDialog()
              }
            }
          }
          
          // 成功通知（管理画面のみ）
          if (this.viewType === 1) {
            this.$buefy.notification.open({
              message: 'セッションが切り替わりました',
              type: 'is-success',
              duration: 3000
            })
          }
          
          // 管理画面の場合の次ノード処理
          if (this.viewType === 1) {
            // シナリオを次のノードへ進める
            if (this.scenario && this.scenario.parameter && this.scenario.parameter[patternIndex] && this.scenario.parameter[patternIndex].next_node) {
              const nextNode = this.scenario.parameter[patternIndex].next_node
              
              // 少し待ってから次のシナリオを取得
              setTimeout(() => {
                this.$store.dispatch('chatbot/getScenarioOne', {
                  companyid: this.data.ckey,
                  scenarioName: this.scenario.name,
                  node: nextNode,
                  rate: this.color.thinking_rate,
                  minipk: this.minipk,
                })
              }, 1000)
            }
          }
        } else {
          throw new Error((response && response.message) || 'セッション作成に失敗しました')
        }
        
      } catch (error) {
        console.error('セッション作成エラー:', error)
        
        // エラーの詳細をログに記録
        if (error.response) {
          console.error('Error response:', {
            status: error.response.status,
            data: error.response.data,
            headers: error.response.headers
          })
        }
        
        // ユーザー向けエラーメッセージ
        let userMessage = 'セッションの切り替えに失敗しました。'
        if (error.response && error.response.status === 401) {
          userMessage += '認証エラーが発生しました。'
        } else if (error.response && error.response.status === 400) {
          userMessage += error.response.data.message || ''
        }
        
        // エラー通知
        if (this.viewType === 1) {
          // 管理画面
          this.$buefy.notification.open({
            message: userMessage,
            type: 'is-danger',
            duration: 5000
          })
        } else {
          // ウィジェットの場合はアラートで表示
          alert(userMessage)
        }
        
      } finally {
        // ローディング非表示（管理画面のみ）
        if (this.viewType === 1) {
          this.$store.commit('common/setLoading', false)
        }
        
        // セッション切替処理中フラグをリセット
        this.isSessionSwitching = false
      }
    },
    
    // 次のノードへ進む処理を別メソッドに分離
    proceedToNextNode(patternIndex) {
      // シナリオを次のノードへ進める
      // 条件分岐パーツではnext_nodeはselect配列にある
      if (this.scenario && 
          this.scenario.select && 
          this.scenario.select[patternIndex] && 
          this.scenario.select[patternIndex].next_node) {
        
        const nextNode = this.scenario.select[patternIndex].next_node
        
        // デバッグログ（開発環境のみ）
        if (process.env.NODE_ENV === 'development') {
          console.log('Proceeding to next node:', {
            currentScenario: this.scenario.name,
            nextNode: nextNode,
            patternIndex: patternIndex
          })
        }
        
        // 次のシナリオを取得
        this.$store.dispatch('chatbot/getScenarioOne', {
          companyid: this.data.ckey,
          scenarioName: this.scenario.name,
          node: nextNode,
          rate: this.color.thinking_rate,
          minipk: this.minipk,
        })
      } else {
        console.warn('Next node information not found in scenario.select:', {
          scenario: this.scenario,
          patternIndex: patternIndex,
          select: this.scenario && this.scenario.select,
          selectAtIndex: this.scenario && this.scenario.select && this.scenario.select[patternIndex]
        })
      }
    },
    
    // 再接続ダイアログ表示メソッド
    showReconnectDialog() {
      // 既存の再接続ダイアログロジックを使用
      if (this.$refs.reconnectDialog) {
        this.$refs.reconnectDialog.show()
      } else {
        // フォールバック: アラート表示
        alert('接続に失敗しました。ページを更新してください。')
      }
    },
  },
  watch: {
    isMessageError() {
      if (this.ws == null) {
        const uri = process.env.WS_ENDPOINT + this.data.ckey + '/' + this.seeker.id + '/'
        this.$store.dispatch('directtalk/connect', { uri: uri, category: 'widget' })
      }
    },
    isAutomatic() {
      const ckey = this.isDemo ? this.companyid : this.data.ckey
      if (
        this.isAutomatic === true &&
        (this.scenario.status === 2 ||
          this.scenario.status === 3 ||
          this.scenario.status === 5 ||
          this.scenario.status === 10 ||
          this.scenario.status === 14 ||
          this.scenario.status === 19 ||
          this.scenario.status === 100)
      ) {
        // 自動進行切替時に動くのは、メッセージのみ(2)、ロボ切替(3)、画像表示(5)、メール送付(10)、動画(14)、回答出力(19)の時
        let scenarioName = null
        let nextNode = null
        if (this.scenario.output_flg === true) {
          scenarioName = this.roboPartsSetOutsideScenario
          nextNode = this.roboPartsSetNextNode
        } else {
          scenarioName = this.scenario.name
          nextNode = this.scenario.select[0].next_node
        }
        this.$store.dispatch('chatbot/getScenarioOne', {
          companyid: ckey,
          scenarioName: scenarioName,
          node: nextNode,
          rate: this.color.thinking_rate,
          minipk: this.minipk,
        })
        let tempTid = this.minipk || (this.viewType === 0 ? this.botid : this.targetID)
        localStorage.setItem(
          'scenariolv_' + tempTid,
          JSON.stringify({
            node: nextNode,
            date: Date().toString(),
            isPartsSet: scenarioName == 'parts-set',
            partsSetOutsideNextNode: scenarioName == 'parts-set' ? this.roboPartsSetNextNode : ''
          })
        )
      }
    },
    recommendDate() {
      let param = this.$_.cloneDeep(this.scenario.parameter)
      if (param.is_hidden_calendar && this.recommendDate.length == undefined) {
        param.count = 5  // 明示的に5を設定
        let divide = 30
        if (param.divide !== undefined) {
          if (divide === 0) {
            divide = 60
          } else {
            divide = 30
          }
        }
        let start = new Date()
        if (param.after) {
          start.setDate(start.getDate() + param.after)
        } else {
          start.setDate(start.getDate())
        }
        this.$store.dispatch('calendar/preserveSuggestedSchedules', {
          suggestedSchedules: start,
          targetID: this.targetID,
        })
        let schedule_start = null
        if (start <= new Date()) {
          //当日を選択
          let now = new Date().getHours() + 3 + new Date().getMinutes() / 100
          if (now < param.work_time_start) {
            schedule_start = new Date()
            schedule_start.setSeconds(0)
            schedule_start.setHours(param.work_time_start)
            schedule_start.setMinutes(param.work_time_start * 100 - schedule_start.getHours() * 100)
          } else {
            schedule_start = new Date()
            schedule_start.setSeconds(0)
            schedule_start.setHours(schedule_start.getHours() + 3)
          }
        } else {
          //翌日以降
          schedule_start = new Date(start)
          schedule_start.setSeconds(0)
          schedule_start.setHours(param.work_time_start)
          schedule_start.setMinutes(param.work_time_start * 100 - schedule_start.getHours() * 100)
        }
        param.after = schedule_start.toLocaleString('ja-JP')
        this.$store.dispatch('calendar/getRecommendSchedule', param)
      } else if (this.recommendDate.start === 'Initialized') {
        this.pushScenarioCalendar()
      } else if (this.recommendDate.length != 0) {
        this.pushScenarioCalendar()
        // 途中経過を保存
        const jsonData = {
          date: this.recommendDate[0].start,
          flg: false,
        }
        const setItemName = 'CAL_' + (this.viewType === 0 ? this.botid : this.targetID)
        localStorage.setItem(setItemName, JSON.stringify(jsonData))
      } else {
        // 希望する日程がないオプションがオンの場合
        if (param.is_nothing_target_date) {
          let confirmMessage = '【候補の日時をお出しできませんでした】\n'
          confirmMessage += '指定日以降、30日以内に、空いている日時が見つかりませんでした。\n'
          confirmMessage += 'カレンダーに戻り、指定日を選択し直しますか？\n'
          confirmMessage += '（指定日を変える事により、空いている日が見つかる場合があります）\n'
          confirmMessage += '※「キャンセル」を選ぶと、次の会話に進みます。'
          const flag = confirm(confirmMessage, )
          // カレンダーに戻る
          if (flag) {
            alert('カレンダーに戻ります。')
            this.$store.dispatch('calendar/resetSuggestedSchedules', this.targetID)
            this.$store.dispatch('calendar/initRecommendSchedule')
            return
          }
          // 次のシナリオの情報取得
          const ckey = this.isDemo ? this.companyid : this.data.ckey
          let scenarioName = null
          let nextNode = null
          if (this.scenario.output_flg === true) {
            scenarioName = this.roboPartsSetOutsideScenario
            nextNode = this.roboPartsSetNextNode
          } else {
            scenarioName = this.scenario.name
            nextNode = this.scenario.select[1].next_node
          }
          // 次のシナリオに進む
          this.$store.dispatch('chatbot/getScenarioOne', {
            companyid: ckey,
            scenarioName: scenarioName,
            node: nextNode,
            rate: this.color.thinking_rate,
            minipk: this.minipk,
          })
        } else {
          //  カレンダーに戻る
          let message = 'ご希望の日付から30日後まで調整できる日程がありませんでした。\nカレンダーに戻って直前で選択した日付の翌日以降から選択し直してください。'
          if (param.no_candidate) {
            message = param.no_candidate
          } else if (this.isDemo) {
            message += '\n\n予定調整者の設定の見直しをお願いいたします。'
          }
          alert(message)
          this.$store.dispatch('calendar/resetSuggestedSchedules', this.targetID)
          this.$store.dispatch('calendar/initRecommendSchedule')
        }
      }
    },
    async scenario() {
      const ckey = this.isDemo ? this.companyid : this.data.ckey

      if (this.isDemo) {
        // デモの場合
        this.isMessage = true
      } else if (this.viewType < 2) {
        // TimeLine以外のボット起動するもの
        // シナリオ履歴を取っておく
        // 自動で次に行くやつの場合
        if (
          this.scenario.status === 2 ||
          this.scenario.status === 3 ||
          this.scenario.status === 5 ||
          this.scenario.status === 9 ||
          this.scenario.status === 10 ||
          this.scenario.status === 12 ||
          this.scenario.status === 14 ||
          this.scenario.status === 16 ||
          this.scenario.status === 19
        ) {
          // 自動的に進んても良いシナリオ
          let scnHistory = {
            scenario: this.scenario.pk,
            chatbot: this.minipk ? null : this.viewType === 0 ? this.botid : this.targetID,
            chatbotmini: this.minipk ? this.minipk : null,
            seeker: this.seeker.pk,
            company: this.widgetData.companyPK,
            start: new Date(),
            end: new Date(),
            url: location.href,
            is_cv: this.scenario.is_cv,
          }
          if (this.scenario.is_cv) {
            const data = {
              timing: 2,
              bot_id: scnHistory.chatbot,
              session_id: this.seeker.id,
              end: new Date()
            }
            this.$store.dispatch('directtalk/setAutoAction', data)
          }
          this.$store.dispatch('chatbot/createScenarioHistoryAny', scnHistory)
        } else {
          // 何かしらボタンを押す等の操作して欲しいシナリオ
          let scnHistory = {
            scenario: this.scenario.pk,
            chatbot: this.minipk ? null : this.viewType === 0 ? this.botid : this.targetID,
            chatbotmini: this.minipk ? this.minipk : null,
            seeker: this.seeker.pk,
            company: this.widgetData.companyPK,
            start: new Date(),
            end: null,
            url: location.href,
            is_cv: false,
          }
          this.$store.dispatch('chatbot/createScenarioHistoryAny', scnHistory)
        }
      }

      // シナリオごとの処理
      if (this.scenario.status === 3) {
        // ロボ切替(3)
        // 前へ戻るの候補を初期化
        this.$store.dispatch('calendar/resetSuggestedSchedules', this.targetID)
        // ロボ切替
        if (!this.isDemo) {
          // デモ以外
          if (!this.scenario.parameter.chatbot) {
            // ミニロボ以外
            this.$store.dispatch('chatbot/setMiniPK', null)
            let bot_info = await this.$store.dispatch('directtalk/getRoboInfo', {'robo_id': this.scenario.parameter.bot_id})
            if (bot_info) {
              this.$store.dispatch('chatbot/setMiniPK', bot_info.pk || null)
              this.$store.dispatch('directtalk/setDT', {
                name: bot_info.display_name,
                icon: bot_info.icon,
                id: bot_info.bot_id,
                model: 'bot',
              })
            }
          } else {
            // ミニロボ
            let bot_info = await this.$store.dispatch('directtalk/getRoboInfo', {'mini_robo_pk': this.scenario.parameter.bot_id})
            if (bot_info) {
              this.$store.dispatch('chatbot/setMiniPK', bot_info.pk)
              this.$store.dispatch('directtalk/setDT', {
                name: bot_info.name,
                icon: bot_info.icon,
                id: bot_info.bot_id,
                model: 'bot',
              })
            }
          }
          this.$store.dispatch('directtalk/createSeekerATHistory', {
            target: this.scenario.parameter.bot_id,
            action: 'select_bot',
            url: this.data.url,
            element: this.scenario.parameter.scenario_name,
          })
          this.$store.dispatch('directtalk/createSeekerATHistory', {
            target: this.targetID,
            action: 'another_robo',
            url: this.data.url,
            element: this.scenario.beforenode,
          })
        } else {
          this.$store.dispatch('chatbot/setMiniPK', this.scenario.parameter.pk)
          this.$store.dispatch('chatbot/getChatBotOne', {
            companyid: this.$route.params.companyid,
            scenario_name: this.scenario.parameter.scenario_name,
          })
        }
        this.$store.dispatch('chatbot/getScenarioOne', {
          companyid: ckey,
          scenarioName: this.scenario.parameter.scenario_name,
          node: 'INITIALIZE',
          rate: this.color.thinking_rate,
          minipk: this.minipk,
        })
        let tempTid = this.minipk || (this.viewType === 0 ? this.botid : this.targetID)
        localStorage.removeItem('scenariolv_' + tempTid)
        this.scnName = this.scenario.parameter.scenario_name
      } else if (this.scenario.status === 4) {
        // 日程自動調整(4)
        this.$store.dispatch('calendar/resetSuggestedSchedules', this.targetID)
        this.$store.dispatch('calendar/initRecommendSchedule')
      } else if (this.scenario.status === 9) {
        // Startに戻る(9)
        if (this.isDemo) {
          // デモの場合
          localStorage.removeItem('NM_demo')
          localStorage.removeItem('EM_demo')
          localStorage.removeItem('TL_demo')
          localStorage.removeItem('AD_demo')
          localStorage.removeItem('FR_demo')
          localStorage.removeItem('SH_demo')
          localStorage.removeItem('GK_demo')
          localStorage.removeItem('BK_demo')
          localStorage.removeItem('SC_demo')
          localStorage.removeItem('SCR')
          localStorage.removeItem('msg')
          this.$store.dispatch('directtalk/clearChatTalkHistory')
        } else {
          // デモ以外
          localStorage.removeItem('SH_' + this.seeker.id)
          localStorage.removeItem('GK_' + this.seeker.id)
          localStorage.removeItem('BK_' + this.seeker.id)
          localStorage.removeItem('SC_' + this.seeker.id)
          localStorage.removeItem('SCR')
          localStorage.removeItem('msg')
          this.$store.dispatch('directtalk/clearChatTalkHistory')
        }
        // 前へ戻るの候補を初期化
        this.$store.dispatch('calendar/resetSuggestedSchedules', this.targetID)
        this.$store.dispatch('chatbot/getScenarioOne', {
          companyid: ckey,
          scenarioName: this.scenario.name,
          node: 'INITIALIZE',
          rate: this.color.thinking_rate,
          minipk: this.minipk,
        })
        let tempTid = this.minipk || (this.viewType === 0 ? this.botid : this.targetID)
        localStorage.removeItem('scenariolv_' + tempTid)
      } else if (this.scenario.status === 10) {
        // メール送付(10)
        if (this.isDemo) {
          // デモの場合
          // チャット上バルーンで表示されないメール送信(10)のシナリオを送出することで、デモ画面編集が行えるようになる
          // デモではメール送信は行わないのでシナリオ送出のみ処理する
          this.pushScenario()
        } else {
          // デモ以外
          let emailContent = this.scenario

          // シナリオ内に記載された代替文字列を置換
          let videoUrl = localStorage.getItem('VU_' + this.seeker.id)
          let lsApplicant = localStorage.getItem('NM_' + this.seeker.id)
          let lsEmail = localStorage.getItem('EM_' + this.seeker.id)
          let lsTel = localStorage.getItem('TL_' + this.seeker.id)
          let lsAddress = localStorage.getItem('AD_' + this.seeker.id)
          let lsFurigana = localStorage.getItem('FR_' + this.seeker.id)
          let lsYyyymmdd = localStorage.getItem('BD_' + this.seeker.id)
          let lsYears = localStorage.getItem('YE_' + this.seeker.id)
          let lsBikou = localStorage.getItem('BK_' + this.seeker.id)
          let lsShikaku = localStorage.getItem('SH_' + this.seeker.id)
          let lsCareer = localStorage.getItem('GK_' + this.seeker.id)
          let lsScedule = localStorage.getItem('SC_' + this.seeker.id)
          let lsPoint = localStorage.getItem('SCR')

          // 本文に動画面接リンク埋め込み
          if (videoUrl) {
            videoUrl =
              '<br><br>------------------------------------------------------------<br>' +
              '動画面接リンク<br>' +
              videoUrl
          } else {
            videoUrl = ''
          }

          // 面接の変更リンク埋め込み
          const dateModifyUrl =
            '<p>' + process.env.OWN_ENDPOINT + '/event_action/' + this.seeker.pk + '</p>'

          // 返信用フォームのリンク埋め込み
          const receivedForm =
            '<p>' + process.env.OWN_ENDPOINT + '/message_login/' + this.seeker.pk + '</p>'
          
          // 継続配信キャンセルリンク埋め込み
          const unsubscribeActionUrl =
            '<p>' + process.env.OWN_ENDPOINT + '/unsubscribe_action/' + this.seeker.pk + '</p>'

            // 応募者詳細画面へのリンク埋め込み
          const is_seeker_subscribed = await this.$store.dispatch('directtalk/isSeekerSubscribed', this.seeker.pk)
          const applicantURL = 
            '<p>' + process.env.OWN_ENDPOINT + '/client/manage?sk=' + this.seeker.pk + '</p>'
          const notAppliedURL = '<a href="' + process.env.OWN_ENDPOINT + '/client/manage' + '">応募者履歴がございませんでした</a>'

          lsApplicant = lsApplicant === null ? '' : lsApplicant
          lsEmail = lsEmail === null ? '' : lsEmail
          lsTel = lsTel === null ? '' : lsTel
          lsAddress = lsAddress === null ? '' : lsAddress
          lsFurigana = lsFurigana === null ? '' : lsFurigana
          lsYyyymmdd = lsYyyymmdd === null ? '' : lsYyyymmdd
          lsYears = lsYears === null ? '' : lsYears
          lsBikou = lsBikou === null ? '' : lsBikou
          lsShikaku = lsShikaku === null ? '' : lsShikaku
          lsCareer = lsCareer === null ? '' : lsCareer
          lsScedule = lsScedule === null ? '' : lsScedule
          lsPoint = lsPoint === null ? '' : lsPoint

          // ユーザのタイムゾーンが日本以外の場合は日本時間に変換
          if (!this.isUserInJapan() && lsScedule) {
            lsScedule = this.convertScheduleMessageToJST(lsScedule) + '（日本時間）'
          }

          emailContent.mainmessage = emailContent.mainmessage
            .replace(new RegExp('__applicant__', 'g'), lsApplicant)
            .replace(new RegExp('__email__', 'g'), lsEmail)
            .replace(new RegExp('__tel__', 'g'), lsTel)
            .replace(new RegExp('__address__', 'g'), lsAddress)
            .replace(new RegExp('__furigana__', 'g'), lsFurigana)
            .replace(new RegExp('__yyyymmdd__', 'g'), lsYyyymmdd)
            .replace(new RegExp('__years__', 'g'), lsYears)
            .replace(new RegExp('__shikaku__', 'g'), lsShikaku)
            .replace(new RegExp('__career__', 'g'), lsCareer)
            .replace(new RegExp('__bikou__', 'g'), lsBikou)
            .replace(new RegExp('__date__', 'g'), lsScedule)
            .replace(new RegExp('__point__', 'g'), lsPoint)
            .replace(new RegExp('__video__', 'g'), videoUrl)
            .replace(new RegExp('__date_modify__', 'g'), dateModifyUrl)
            .replace(new RegExp('__received_form__', 'g'), receivedForm)
            .replace(new RegExp('__unsubscribe_action__', 'g'), unsubscribeActionUrl)
            .replace(new RegExp('__applicanturl__', 'g'), (is_seeker_subscribed ? applicantURL : notAppliedURL))
          emailContent.parameter.title = emailContent.parameter.title
            .replace(new RegExp('__applicant__', 'g'), lsApplicant)
            .replace(new RegExp('__email__', 'g'), lsEmail)
            .replace(new RegExp('__tel__', 'g'), lsTel)
            .replace(new RegExp('__address__', 'g'), lsAddress)
            .replace(new RegExp('__furigana__', 'g'), lsFurigana)
            .replace(new RegExp('__yyyymmdd__', 'g'), lsYyyymmdd)
            .replace(new RegExp('__years__', 'g'), lsYears)
            .replace(new RegExp('__shikaku__', 'g'), lsShikaku)
            .replace(new RegExp('__career__', 'g'), lsCareer)
            .replace(new RegExp('__bikou__', 'g'), lsBikou)
            .replace(new RegExp('__date__', 'g'), lsScedule)
            .replace(new RegExp('__point__', 'g'), lsPoint)
          emailContent.parameter.to = emailContent.parameter.to
            .replace(new RegExp('__applicant__', 'g'), lsApplicant)
            .replace(new RegExp('__email__', 'g'), lsEmail)
            .replace(new RegExp('__tel__', 'g'), lsTel)
            .replace(new RegExp('__address__', 'g'), lsAddress)
            .replace(new RegExp('__furigana__', 'g'), lsFurigana)
            .replace(new RegExp('__yyyymmdd__', 'g'), lsYyyymmdd)
            .replace(new RegExp('__years__', 'g'), lsYears)
            .replace(new RegExp('__shikaku__', 'g'), lsShikaku)
            .replace(new RegExp('__career__', 'g'), lsCareer)
            .replace(new RegExp('__bikou__', 'g'), lsBikou)
            .replace(new RegExp('__date__', 'g'), lsScedule)
            .replace(new RegExp('__point__', 'g'), lsPoint)
          if (emailContent.parameter.cc) {
            emailContent.parameter.cc = emailContent.parameter.cc
              .replace(new RegExp('__applicant__', 'g'), lsApplicant)
              .replace(new RegExp('__email__', 'g'), lsEmail)
              .replace(new RegExp('__tel__', 'g'), lsTel)
              .replace(new RegExp('__address__', 'g'), lsAddress)
              .replace(new RegExp('__furigana__', 'g'), lsFurigana)
              .replace(new RegExp('__yyyymmdd__', 'g'), lsYyyymmdd)
              .replace(new RegExp('__years__', 'g'), lsYears)
              .replace(new RegExp('__shikaku__', 'g'), lsShikaku)
              .replace(new RegExp('__career__', 'g'), lsCareer)
              .replace(new RegExp('__bikou__', 'g'), lsBikou)
              .replace(new RegExp('__date__', 'g'), lsScedule)
              .replace(new RegExp('__point__', 'g'), lsPoint)
          }
          let tempChatTalkHistory = this.chatTalkHistory.slice().reverse()
          for (const history of tempChatTalkHistory) {
            // 会話履歴の応募フォームから置換
            if (history.quoteWords !== undefined && history.speaker === 'my') {
              if (history.status === 1 || history.status === 8) {
                // 応募フォーム or 履歴書フォームのとき
                const replaceName = history.quoteAnswers.name
                const replaceFurigana = history.quoteAnswers.furigana
                const replaceEmail = history.quoteAnswers.email
                const replaceTel = history.quoteAnswers.tel
                let replaceGender = ''
                if (history.quoteAnswers.gender == 0) {
                  replaceGender = '未選択'
                } else if (history.quoteAnswers.gender == 1) {
                  replaceGender = '男性'
                } else if (history.quoteAnswers.gender == 2) {
                  replaceGender = '女性'
                } else if (history.quoteAnswers.gender == 3) {
                  replaceGender = '選択しない'
                }
                const replaceAddress = history.quoteAnswers.address
                const replaceBirth = history.quoteAnswers.birth
                const replaceMessage = history.quoteAnswers.msg
                let birth = replaceBirth
                if (birth) {
                  if (typeof(birth) === "object") {
                    birth = birth.getFullYear() + '/' + (birth.getMonth() + 1) + '/' + birth.getDate()
                  }
                }
                emailContent.mainmessage = emailContent.mainmessage
                  .replace(new RegExp(history.quoteWords.name, 'g'), replaceName)
                  .replace(new RegExp(history.quoteWords.furigana, 'g'), replaceFurigana)
                  .replace(new RegExp(history.quoteWords.email, 'g'), replaceEmail)
                  .replace(new RegExp(history.quoteWords.tel, 'g'), replaceTel)
                  .replace(new RegExp(history.quoteWords.gender, 'g'), replaceGender)
                  .replace(new RegExp(history.quoteWords.address, 'g'), replaceAddress)
                  .replace(new RegExp(history.quoteWords.birth, 'g'), birth)
                  .replace(new RegExp(history.quoteWords.message, 'g'), replaceMessage)
                emailContent.parameter.title = emailContent.parameter.title
                  .replace(new RegExp(history.quoteWords.name, 'g'), replaceName)
                  .replace(new RegExp(history.quoteWords.furigana, 'g'), replaceFurigana)
                  .replace(new RegExp(history.quoteWords.email, 'g'), replaceEmail)
                  .replace(new RegExp(history.quoteWords.tel, 'g'), replaceTel)
                  .replace(new RegExp(history.quoteWords.gender, 'g'), replaceGender)
                  .replace(new RegExp(history.quoteWords.address, 'g'), replaceAddress)
                  .replace(new RegExp(history.quoteWords.birth, 'g'), birth)
                  .replace(new RegExp(history.quoteWords.message, 'g'), replaceMessage)
                emailContent.parameter.to = emailContent.parameter.to
                  .replace(new RegExp(history.quoteWords.name, 'g'), replaceName)
                  .replace(new RegExp(history.quoteWords.furigana, 'g'), replaceFurigana)
                  .replace(new RegExp(history.quoteWords.email, 'g'), replaceEmail)
                  .replace(new RegExp(history.quoteWords.tel, 'g'), replaceTel)
                  .replace(new RegExp(history.quoteWords.gender, 'g'), replaceGender)
                  .replace(new RegExp(history.quoteWords.address, 'g'), replaceAddress)
                  .replace(new RegExp(history.quoteWords.birth, 'g'), birth)
                  .replace(new RegExp(history.quoteWords.message, 'g'), replaceMessage)
                if (emailContent.parameter.cc) {
                  emailContent.parameter.cc = emailContent.parameter.cc
                    .replace(new RegExp(history.quoteWords.name, 'g'), replaceName)
                    .replace(new RegExp(history.quoteWords.furigana, 'g'), replaceFurigana)
                    .replace(new RegExp(history.quoteWords.email, 'g'), replaceEmail)
                    .replace(new RegExp(history.quoteWords.tel, 'g'), replaceTel)
                    .replace(new RegExp(history.quoteWords.gender, 'g'), replaceGender)
                    .replace(new RegExp(history.quoteWords.address, 'g'), replaceAddress)
                    .replace(new RegExp(history.quoteWords.birth, 'g'), birth)
                    .replace(new RegExp(history.quoteWords.message, 'g'), replaceMessage)
                }
              }
              else if (history.status == 15) {
                // プルダウンのとき
                const keys = Object.keys(history.quoteAnswers)
                for (let k of keys) {
                  if (history.quoteWords[k] && history.quoteAnswers[k]) {
                    emailContent.mainmessage = emailContent.mainmessage.replace(new RegExp(history.quoteWords[k], 'g'), history.quoteAnswers[k])
                    emailContent.parameter.title = emailContent.parameter.title.replace(new RegExp(history.quoteWords[k], 'g'), history.quoteAnswers[k])
                    emailContent.parameter.to = emailContent.parameter.to.replace(new RegExp(history.quoteWords[k], 'g'), history.quoteAnswers[k])
                    if (emailContent.parameter.cc) {
                      emailContent.parameter.cc = emailContent.parameter.cc.replace(new RegExp(history.quoteWords[k], 'g'), history.quoteAnswers[k])
                    }
                  }
                }
                if (history.quoteWords.answer) {
                  emailContent.mainmessage = emailContent.mainmessage.replace(new RegExp(history.quoteWords.answer, 'g'), history.message)
                  emailContent.parameter.title = emailContent.parameter.title.replace(new RegExp(history.quoteWords.answer, 'g'), history.message)
                  emailContent.parameter.to = emailContent.parameter.to.replace(new RegExp(history.quoteWords.answer, 'g'), history.message)
                  if (emailContent.parameter.cc) {
                    emailContent.parameter.cc = emailContent.parameter.cc.replace(new RegExp(history.quoteWords.answer, 'g'), history.message)
                  }
                }
              }
              else {
                // それ以外（日程調整パーツを含む）
                let replaceMessage = history.message
                
                // 日程調整パーツの場合の特別処理
                if (history.status === 4) {
                  // ユーザーのタイムゾーンが日本以外の場合
                  if (!this.isUserInJapan()) {
                    // 日時文字列を日本時間に変換してから「（日本時間）」を付記
                    replaceMessage = this.convertScheduleMessageToJST(history.message) + '（日本時間）'
                  }
                }
                
                emailContent.mainmessage = emailContent.mainmessage.replace(
                  new RegExp(history.quoteWords.answer, 'g'),
                  replaceMessage
                )
                emailContent.parameter.title = emailContent.parameter.title.replace(
                  new RegExp(history.quoteWords.answer, 'g'),
                  replaceMessage
                )
                emailContent.parameter.to = emailContent.parameter.to.replace(
                  new RegExp(history.quoteWords.answer, 'g'),
                  replaceMessage
                )
                if (emailContent.parameter.cc) {
                  emailContent.parameter.cc = emailContent.parameter.cc.replace(
                    new RegExp(history.quoteWords.answer, 'g'),
                    replaceMessage
                  )
                }
              }
            }
          }
          // ロボ引用がある場合
          if (this.roboArguments) {
            for (const arg of this.roboArguments) {
              // 本文のロボ引用を置換
              emailContent.mainmessage = emailContent.mainmessage.replace(
                new RegExp(arg.key, 'g'),
                arg.value
              )
              // タイトルのロボ引用を置換
              emailContent.parameter.title = emailContent.parameter.title.replace(
                new RegExp(arg.key, 'g'),
                arg.value
              )
              // Toのロボ引用を置換
              emailContent.parameter.to = emailContent.parameter.to.replace(
                new RegExp(arg.key, 'g'),
                arg.value
              )
              // Ccのロボ引用を置換
              if (emailContent.parameter.cc) {
                emailContent.parameter.cc = emailContent.parameter.cc.replace(
                  new RegExp(arg.key, 'g'),
                  arg.value
                )
              }
            }
          }
          // 置換できなかったロボ引用は削除
          emailContent.mainmessage = emailContent.mainmessage.replace(
            new RegExp(/__robo_quote\.([a-z0-9]+|[a-z]+)__/, 'g'),
            ''
          )
          emailContent.parameter.title = emailContent.parameter.title.replace(
            new RegExp(/__(\d+|\d+\.[a-z0-9]+|[a-z]+)__/, 'g'),
            ''
          )
          emailContent.parameter.to = emailContent.parameter.to.replace(
            new RegExp(/__(\d+|\d+\.[a-z0-9]+|[a-z]+)__/, 'g'),
            ''
          )
          emailContent.parameter.cc = emailContent.parameter.cc.replace(
            new RegExp(/__(\d+|\d+\.[a-z0-9]+|[a-z]+)__/, 'g'),
            ''
          )

          // 置換しきれなかった代替文字列を削除
          emailContent.mainmessage = emailContent.mainmessage.replace(
            new RegExp(/__(\d+|\d+\.[a-z0-9]+|[a-z]+)__/, 'g'),
            ''
          )
          emailContent.parameter.title = emailContent.parameter.title.replace(
            new RegExp(/__(\d+|\d+\.[a-z0-9]+|[a-z]+)__/, 'g'),
            ''
          )
          emailContent.parameter.to = emailContent.parameter.to.replace(
            new RegExp(/__(\d+|\d+\.[a-z0-9]+|[a-z]+)__/, 'g'),
            ''
          )
          if (emailContent.parameter.cc) {
            emailContent.parameter.cc = emailContent.parameter.cc.replace(
              new RegExp(/__(\d+|\d+\.[a-z0-9]+|[a-z]+)__/, 'g'),
              ''
            )
          }

          // メール内容のエスケープ文字置換
          emailContent.mainmessage = alterReplace(emailContent.mainmessage, true)
          emailContent.parameter.to = alterReplace(emailContent.parameter.to, true)
          emailContent.parameter.cc = alterReplace(emailContent.parameter.cc, true)
          emailContent.parameter.bcc = alterReplace(emailContent.parameter.bcc, true)
          //改行を<br>タグに変換
          emailContent.mainmessage = emailContent.mainmessage.replace(/\n/g, '<br>')
          if (emailContent.parameter.is_same_day === true || emailContent.parameter.after === 0) {
            // メール送信タイミングの判定
            this.$store.dispatch('chatbot/sendEmailScenario', {
              content: emailContent,
              seeker: this.seeker.id,
              chatbot: this.chatbot ? this.chatbot.bot_id : this.targetID,
              is_demo: false,
            })
          }
          if (emailContent.parameter.after > 0) {
            // メール遅延送信
            emailContent.parameter.mainmessage = emailContent.mainmessage
            emailContent.parameter.seeker = this.seeker.id
            emailContent.parameter.chatbot = this.chatbot ? this.chatbot.bot_id : this.targetID
            this.$store.dispatch('chatbot/createSendScheduledMessage', {
              sessionid: this.seeker.id,
              status: 0,
              parameter: emailContent.parameter,
              schedule: new Date(moment(new Date()).add('days', emailContent.parameter.after)),
              is_finished: false,
              error_log: null,
            })
          }
        }
        let scenarioName = null
        let nextNode = null
        if (this.scenario.output_flg === true) {
          scenarioName = this.roboPartsSetOutsideScenario
          nextNode = this.roboPartsSetNextNode
        } else {
          scenarioName = this.scenario.name
          nextNode = this.scenario.select[0].next_node
        }
        this.$store.dispatch('chatbot/getScenarioOne', {
          companyid: ckey,
          scenarioName: scenarioName,
          node: nextNode,
          rate: this.color.thinking_rate,
          minipk: this.minipk,
        })
        let tempTid = this.minipk || (this.viewType === 0 ? this.botid : this.targetID)
        localStorage.setItem(
          'scenariolv_' + tempTid,
          JSON.stringify({
            node: nextNode,
            date: Date().toString(),
            isPartsSet: scenarioName == 'parts-set',
            partsSetOutsideNextNode: scenarioName == 'parts-set' ? this.roboPartsSetNextNode : ''
          })
        )
      } else if (this.scenario.status === 12) {
        // 条件で分ける(12)
        let lsApplicant = ''
        let lsEmail = ''
        let lsTel = ''
        let lsAddress = ''
        let lsFurigana = ''
        let lsYyyymmdd = ''
        let lsYears = ''
        let lsBikou = ''
        let lsShikaku = ''
        let lsCareer = ''
        let lsScedule = ''
        let lsPoint = ''

        if (this.isDemo) {
          // デモの場合
          // チャット上バルーンで表示されない条件分岐(12)のシナリオも送出することで、デモ画面編集が行えるようになる
          lsApplicant = localStorage.getItem('NM_demo')
          lsEmail = localStorage.getItem('EM_demo')
          lsTel = localStorage.getItem('TL_demo')
          lsAddress = localStorage.getItem('AD_demo')
          lsFurigana = localStorage.getItem('FR_demo')
          lsYyyymmdd = localStorage.getItem('BD_demo')
          lsYears = localStorage.getItem('YE_demo')
          lsBikou = localStorage.getItem('BK_demo')
          lsShikaku = localStorage.getItem('SH_demo')
          lsCareer = localStorage.getItem('GK_demo')
          lsScedule = localStorage.getItem('SC_demo')
          lsPoint = localStorage.getItem('SCR')
          this.pushScenario()
        } else {
          // デモ以外の場合
          // 訪問者のidから取得
          lsApplicant = localStorage.getItem('NM_' + this.seeker.id)
          lsEmail = localStorage.getItem('EM_' + this.seeker.id)
          lsTel = localStorage.getItem('TL_' + this.seeker.id)
          lsAddress = localStorage.getItem('AD_' + this.seeker.id)
          lsFurigana = localStorage.getItem('FR_' + this.seeker.id)
          lsYyyymmdd = localStorage.getItem('BD_' + this.seeker.id)
          lsYears = localStorage.getItem('YE_' + this.seeker.id)
          lsBikou = localStorage.getItem('BK_' + this.seeker.id)
          lsShikaku = localStorage.getItem('SH_' + this.seeker.id)
          lsCareer = localStorage.getItem('GK_' + this.seeker.id)
          lsScedule = localStorage.getItem('SC_' + this.seeker.id)
          lsPoint = localStorage.getItem('SCR')
        }
        const userSendScore = Number(localStorage.getItem('SCR'))
        const randomBranch = Math.floor(Math.random() * Object.keys(this.scenario.parameter).length)
        let foundNextScenario = false
        for (const [idx, param] of this.scenario.parameter.entries()) {
          // シナリオ内に記載された代替文字列を置換
          lsApplicant = lsApplicant === null ? '' : lsApplicant
          lsEmail = lsEmail === null ? '' : lsEmail
          lsTel = lsTel === null ? '' : lsTel
          lsAddress = lsAddress === null ? '' : lsAddress
          lsFurigana = lsFurigana === null ? '' : lsFurigana
          lsYyyymmdd = lsYyyymmdd === null ? '' : lsYyyymmdd
          lsYears = lsYears === null ? '' : lsYears
          lsBikou = lsBikou === null ? '' : lsBikou
          lsShikaku = lsShikaku === null ? '' : lsShikaku
          lsCareer = lsCareer === null ? '' : lsCareer
          lsScedule = lsScedule === null ? '' : lsScedule
          lsPoint = lsPoint === null ? '' : lsPoint

          let word = param.wordList[0].word
            .replace(new RegExp('__applicant__', 'g'), lsApplicant)
            .replace(new RegExp('__email__', 'g'), lsEmail)
            .replace(new RegExp('__tel__', 'g'), lsTel)
            .replace(new RegExp('__address__', 'g'), lsAddress)
            .replace(new RegExp('__furigana__', 'g'), lsFurigana)
            .replace(new RegExp('__yyyymmdd__', 'g'), lsYyyymmdd)
            .replace(new RegExp('__years__', 'g'), lsYears)
            .replace(new RegExp('__shikaku__', 'g'), lsShikaku)
            .replace(new RegExp('__career__', 'g'), lsCareer)
            .replace(new RegExp('__bikou__', 'g'), lsBikou)
            .replace(new RegExp('__date__', 'g'), lsScedule)
            .replace(new RegExp('__point__', 'g'), lsPoint)

          for (const history of this.chatTalkHistory) {
            // 会話履歴の応募フォームから置換
            if (history.quoteWords !== undefined && history.speaker === 'my') {
              if (history.status === 1 || history.status === 8) {
                // 応募フォーム or 履歴書フォームのとき
                const replaceName = history.quoteAnswers.name
                const replaceFurigana = history.quoteAnswers.furigana
                const replaceEmail = history.quoteAnswers.email
                const replaceTel = history.quoteAnswers.tel
                let replaceGender = ''
                if (history.quoteAnswers.gender == 0) {
                  replaceGender = '未選択'
                } else if (history.quoteAnswers.gender == 1) {
                  replaceGender = '男性'
                } else if (history.quoteAnswers.gender == 2) {
                  replaceGender = '女性'
                } else if (history.quoteAnswers.gender == 3) {
                  replaceGender = '選択しない'
                }
                const replaceAddress = history.quoteAnswers.address
                const replaceBirth = history.quoteAnswers.birth
                const replaceMessage = history.quoteAnswers.msg
                let birth = replaceBirth
                if (birth) {
                  if (typeof(birth) === "object") {
                    birth = birth.getFullYear() + '/' + (birth.getMonth() + 1) + '/' + birth.getDate()
                  }
                }
                word = word
                  .replace(new RegExp(history.quoteWords.name, 'g'), replaceName)
                  .replace(new RegExp(history.quoteWords.furigana, 'g'), replaceFurigana)
                  .replace(new RegExp(history.quoteWords.email, 'g'), replaceEmail)
                  .replace(new RegExp(history.quoteWords.tel, 'g'), replaceTel)
                  .replace(new RegExp(history.quoteWords.gender, 'g'), replaceGender)
                  .replace(new RegExp(history.quoteWords.address, 'g'), replaceAddress)
                  .replace(new RegExp(history.quoteWords.birth, 'g'), birth)
                  .replace(new RegExp(history.quoteWords.message, 'g'), replaceMessage)
              }
              else if (history.status == 15) {
                // プルダウンのとき
                const keys = Object.keys(history.quoteAnswers)
                for (let k of keys) {
                  if (history.quoteWords[k] && history.quoteAnswers[k]) word = word.replace(new RegExp(history.quoteWords[k], 'g'), history.quoteAnswers[k])
                }
                if (history.quoteWords.answer) word = word.replace(new RegExp(history.quoteWords.answer, 'g'), history.message)
              }
              else {
                // 応募フォーム以外
                word = word.replace(new RegExp(history.quoteWords.answer, 'g'), history.message)
              }
            }
          }

          // ロボ引用がある場合
          if (this.roboArguments) {
            for (const arg of this.roboArguments) {
              word = word.replace(
                new RegExp(arg.key, 'g'),
                arg.value
              )
            }
          }
          // 置換できなかったロボ引用は削除
          word = word.replace(
            new RegExp(/__robo_quote\.([a-z0-9]+|[a-z]+)__/, 'g'),
            ''
          )

          // 置換しきれなかった代替文字列を削除
          word = word.replace(new RegExp(/__(\d+|\d+\.[a-z0-9]+|[a-z]+)__/, 'g'), '')

          // 条件ワード取得
          let userSendMessageArray = null
          if (!Number(param.wordList[0].parts)) {
            // 直前のパーツ
            const userSendMessage = localStorage.getItem('msg')
            userSendMessageArray = userSendMessage ? userSendMessage.split(',') : null
          } else {
            // 指定したパーツ
            const tempChatTalkHistory = this.chatTalkHistory.slice().reverse()
            const userSendMessage = tempChatTalkHistory.find(hist => hist.speaker === 'my' && hist.pk == param.wordList[0].parts)
            userSendMessageArray = userSendMessage ? userSendMessage.message.split(',') : null
          }

          if (param.wordList[0].terms !== '' && userSendMessageArray === null) continue

          if (this.roboArguments && userSendMessageArray) {
            for (let msg of userSendMessageArray) {
              for (const arg of this.roboArguments) {
                msg = msg.replace(
                  new RegExp(arg.key, 'g'),
                  arg.value
                )
              }
              // 置換できなかったロボ引用は削除
              msg = msg.replace(
                new RegExp(/__robo_quote\.([a-z0-9]+|[a-z]+)__/, 'g'),
                ''
              )
            }
          }

          // 条件の定義順に突合して、最初に条件一致したものを採用
          let isMatch = false
          if (param.wordList[0].terms === '一致する') {
            for (let msg of userSendMessageArray) {
              if (word === msg) {
                isMatch = true
                break
              }
            }
          } else if (param.wordList[0].terms === '異なる') {
            let unmatch_count = 0
            for (let msg of userSendMessageArray) {
              if (word !== msg) {
                unmatch_count++
              }
            }
            if (unmatch_count === userSendMessageArray.length) {
              isMatch = true
            }
          } else if (param.wordList[0].terms === '含む') {
            for (let msg of userSendMessageArray) {
              if (msg.includes(word)) {
                isMatch = true
                break
              }
            }
          } else if (param.wordList[0].terms === '含まない') {
            for (let msg of userSendMessageArray) {
              if (!msg.includes(word)) {
                isMatch = true
                break
              }
            }
          } else if (param.userInfoList && param.userInfoList[0].terms === '一致する') {
            let info = this.roboArguments.find(arg => arg.key === "__robo_quote."+param.userInfoList[0].column_pk+"__")
            if (info && info.value === param.userInfoList[0].word) {
              isMatch = true
            }
          } else if (param.userInfoList && param.userInfoList[0].terms === '異なる') {
            let info = this.roboArguments.find(arg => arg.key === "__robo_quote."+param.userInfoList[0].column_pk+"__")
            if (!info || info.value !== param.userInfoList[0].word) {
              isMatch = true
            }
          } else if (param.userInfoList && param.userInfoList[0].terms === '含む') {
            let info = this.roboArguments.find(arg => arg.key === "__robo_quote."+param.userInfoList[0].column_pk+"__")
            if (info && info.value.includes(param.userInfoList[0].word)) {
              isMatch = true
            }
          } else if (param.userInfoList && param.userInfoList[0].terms === '含まない') {
            let info = this.roboArguments.find(arg => arg.key === "__robo_quote."+param.userInfoList[0].column_pk+"__")
            if (!info || !info.value.includes(param.userInfoList[0].word)) {
              isMatch = true
            }
          } else if (param.miniroboVarsList && param.miniroboVarsList[0].terms === '一致する') {
            if (param.miniroboVarsList[0].word === param.miniroboVarsList[0].variable) {
              isMatch = true
            }
          } else if (param.miniroboVarsList && param.miniroboVarsList[0].terms === '異なる') {
            if (param.miniroboVarsList[0].word !== param.miniroboVarsList[0].variable) {
              isMatch = true
            }
          } else if (param.miniroboVarsList && param.miniroboVarsList[0].terms === '含む') {
            if (param.miniroboVarsList[0].variable.includes(param.miniroboVarsList[0].word)) {
              isMatch = true
            }
          } else if (param.miniroboVarsList && param.miniroboVarsList[0].terms === '含まない') {
            if (!param.miniroboVarsList[0].variable.includes(param.miniroboVarsList[0].word)) {
              isMatch = true
            }
          } else if (param.pointList[0].terms === '以上') {
            if (param.pointList[0].point <= userSendScore) {
              isMatch = true
              if (param.pointList[0].reset) localStorage.setItem('SCR', 0)
            }
          } else if (param.pointList[0].terms === '未満') {
            if (param.pointList[0].point > userSendScore) {
              isMatch = true
              if (param.pointList[0].reset) localStorage.setItem('SCR', 0)
            }
          } else if (param.random === true) {
            if (randomBranch === idx) {
              isMatch = true
            }
          } else if (param.sessionSwitch === true) {
            // デモ環境ではセッション切替をスキップ
            if (this.isDemo) {
              console.log('セッション切替はデモ環境では利用できません')
              alert('セッション切替機能はデモ環境では利用できません。本番環境でのみ動作します。')
              // デモ環境でも次のノードへ進む
              isMatch = true
            } else {
              // セッション切替タイプの分岐パーツの場合、必ず新規セッションを作成
              await this.createNewSessionFromBranch(idx)
              // セッション切替処理が完了したので、これ以上の処理は不要
              return
            }
          }

          if (isMatch) {
            let scenarioName = null
            let nextNode = null
            if (this.scenario.output_flg === true) {
              scenarioName = this.roboPartsSetOutsideScenario
              nextNode = this.roboPartsSetNextNode
            } else {
              scenarioName = this.scenario.name
              nextNode = this.scenario.select[idx].next_node
            }
            this.$store.dispatch('chatbot/getScenarioOne', {
              companyid: ckey,
              scenarioName: scenarioName,
              node: nextNode,
              rate: this.color.thinking_rate,
              minipk: this.minipk,
            })
            let tempTid = this.minipk || (this.viewType === 0 ? this.botid : this.targetID)
            localStorage.setItem(
              'scenariolv_' + tempTid,
              JSON.stringify({
                node: nextNode,
                date: Date().toString(),
                isPartsSet: scenarioName == 'parts-set',
                partsSetOutsideNextNode: scenarioName == 'parts-set' ? this.roboPartsSetNextNode : ''
              })
            )
            foundNextScenario = true
            break
          }
        }
        if (!foundNextScenario) {
          alert('有効な回答が見つかりませんでした。')
        }
      } else if (this.scenario.status === 16) {
        // SMS送付(16)
        if (this.isDemo) {
          // デモの場合
          // チャット上バルーンで表示されないSMS送信(16)のシナリオを送出することで、デモ画面編集が行えるようになる
          // デモではメール送信は行わないのでシナリオ送出のみ処理する
          this.pushScenario()
        } else {
          // デモ以外
          let smsContent = this.scenario

          // シナリオ内に記載された代替文字列を置換
          let lsApplicant = localStorage.getItem('NM_' + this.seeker.id)
          let lsEmail = localStorage.getItem('EM_' + this.seeker.id)
          let lsTel = localStorage.getItem('TL_' + this.seeker.id)
          let lsAddress = localStorage.getItem('AD_' + this.seeker.id)
          let lsFurigana = localStorage.getItem('FR_' + this.seeker.id)
          let lsYyyymmdd = localStorage.getItem('BD_' + this.seeker.id)
          let lsYears = localStorage.getItem('YE_' + this.seeker.id)
          let lsBikou = localStorage.getItem('BK_' + this.seeker.id)
          let lsShikaku = localStorage.getItem('SH_' + this.seeker.id)
          let lsCareer = localStorage.getItem('GK_' + this.seeker.id)
          let lsScedule = localStorage.getItem('SC_' + this.seeker.id)
          let lsPoint = localStorage.getItem('SCR')

          lsApplicant = lsApplicant === null ? '' : lsApplicant
          lsEmail = lsEmail === null ? '' : lsEmail
          lsTel = lsTel === null ? '' : lsTel
          lsAddress = lsAddress === null ? '' : lsAddress
          lsFurigana = lsFurigana === null ? '' : lsFurigana
          lsYyyymmdd = lsYyyymmdd === null ? '' : lsYyyymmdd
          lsYears = lsYears === null ? '' : lsYears
          lsBikou = lsBikou === null ? '' : lsBikou
          lsShikaku = lsShikaku === null ? '' : lsShikaku
          lsCareer = lsCareer === null ? '' : lsCareer
          lsScedule = lsScedule === null ? '' : lsScedule
          lsPoint = lsPoint === null ? '' : lsPoint
          const dateModifyUrl = process.env.OWN_ENDPOINT + '/event_action/' + this.seeker.pk
          const unsubscribeActionUrl = process.env.OWN_ENDPOINT + '/unsubscribe_action/' + this.seeker.pk

          smsContent.mainmessage = smsContent.mainmessage
            .replace(new RegExp('__applicant__', 'g'), lsApplicant)
            .replace(new RegExp('__email__', 'g'), lsEmail)
            .replace(new RegExp('__tel__', 'g'), lsTel)
            .replace(new RegExp('__address__', 'g'), lsAddress)
            .replace(new RegExp('__furigana__', 'g'), lsFurigana)
            .replace(new RegExp('__yyyymmdd__', 'g'), lsYyyymmdd)
            .replace(new RegExp('__years__', 'g'), lsYears)
            .replace(new RegExp('__shikaku__', 'g'), lsShikaku)
            .replace(new RegExp('__career__', 'g'), lsCareer)
            .replace(new RegExp('__bikou__', 'g'), lsBikou)
            .replace(new RegExp('__date__', 'g'), lsScedule)
            .replace(new RegExp('__point__', 'g'), lsPoint)
            .replace(new RegExp('__date_modify__', 'g'), dateModifyUrl)
            .replace(new RegExp('__unsubscribe_action__', 'g'), unsubscribeActionUrl)
          smsContent.parameter.to = smsContent.parameter.to
            .replace(new RegExp('__applicant__', 'g'), lsApplicant)
            .replace(new RegExp('__email__', 'g'), lsEmail)
            .replace(new RegExp('__tel__', 'g'), lsTel)
            .replace(new RegExp('__address__', 'g'), lsAddress)
            .replace(new RegExp('__furigana__', 'g'), lsFurigana)
            .replace(new RegExp('__yyyymmdd__', 'g'), lsYyyymmdd)
            .replace(new RegExp('__years__', 'g'), lsYears)
            .replace(new RegExp('__shikaku__', 'g'), lsShikaku)
            .replace(new RegExp('__career__', 'g'), lsCareer)
            .replace(new RegExp('__bikou__', 'g'), lsBikou)
            .replace(new RegExp('__date__', 'g'), lsScedule)
            .replace(new RegExp('__point__', 'g'), lsPoint)
          let tempChatTalkHistory = this.chatTalkHistory.slice().reverse()
          for (const history of tempChatTalkHistory) {
            // 会話履歴の応募フォームから置換
            if (history.quoteWords !== undefined && history.speaker === 'my') {
              if (history.status === 1 || history.status === 8) {
                // 応募フォーム or 履歴書フォームのとき
                const replaceName = history.quoteAnswers.name
                const replaceFurigana = history.quoteAnswers.furigana
                const replaceEmail = history.quoteAnswers.email
                const replaceTel = history.quoteAnswers.tel
                let replaceGender = ''
                if (history.quoteAnswers.gender == 0) {
                  replaceGender = '未選択'
                } else if (history.quoteAnswers.gender == 1) {
                  replaceGender = '男性'
                } else if (history.quoteAnswers.gender == 2) {
                  replaceGender = '女性'
                } else if (history.quoteAnswers.gender == 3) {
                  replaceGender = '選択しない'
                }
                const replaceAddress = history.quoteAnswers.address
                const replaceBirth = history.quoteAnswers.birth
                const replaceMessage = history.quoteAnswers.msg
                let birth = replaceBirth
                if (birth) {
                  if (typeof(birth) === "object") {
                    birth = birth.getFullYear() + '/' + (birth.getMonth() + 1) + '/' + birth.getDate()
                  }
                }
                smsContent.mainmessage = smsContent.mainmessage
                  .replace(new RegExp(history.quoteWords.name, 'g'), replaceName)
                  .replace(new RegExp(history.quoteWords.furigana, 'g'), replaceFurigana)
                  .replace(new RegExp(history.quoteWords.email, 'g'), replaceEmail)
                  .replace(new RegExp(history.quoteWords.tel, 'g'), replaceTel)
                  .replace(new RegExp(history.quoteWords.gender, 'g'), replaceGender)
                  .replace(new RegExp(history.quoteWords.address, 'g'), replaceAddress)
                  .replace(new RegExp(history.quoteWords.birth, 'g'), birth)
                  .replace(new RegExp(history.quoteWords.message, 'g'), replaceMessage)
                smsContent.parameter.to = smsContent.parameter.to
                  .replace(new RegExp(history.quoteWords.name, 'g'), replaceName)
                  .replace(new RegExp(history.quoteWords.furigana, 'g'), replaceFurigana)
                  .replace(new RegExp(history.quoteWords.email, 'g'), replaceEmail)
                  .replace(new RegExp(history.quoteWords.tel, 'g'), replaceTel)
                  .replace(new RegExp(history.quoteWords.gender, 'g'), replaceGender)
                  .replace(new RegExp(history.quoteWords.address, 'g'), replaceAddress)
                  .replace(new RegExp(history.quoteWords.birth, 'g'), birth)
                  .replace(new RegExp(history.quoteWords.message, 'g'), replaceMessage)
              }
              else if (history.status == 15) {
                // プルダウンのとき
                const keys = Object.keys(history.quoteAnswers)
                for (let k of keys) {
                  if (history.quoteWords[k] && history.quoteAnswers[k]) {
                    smsContent.mainmessage = smsContent.mainmessage.replace(new RegExp(history.quoteWords[k], 'g'), history.quoteAnswers[k])
                    smsContent.parameter.to = smsContent.parameter.to.replace(new RegExp(history.quoteWords[k], 'g'), history.quoteAnswers[k])
                  }
                }
                if (history.quoteWords.answer) {
                  smsContent.mainmessage = smsContent.mainmessage.replace(new RegExp(history.quoteWords.answer, 'g'), history.message)
                  smsContent.parameter.to = smsContent.parameter.to.replace(new RegExp(history.quoteWords.answer, 'g'), history.message)
                }
              }
              else {
                // 応募フォーム以外
                smsContent.mainmessage = smsContent.mainmessage.replace(
                  new RegExp(history.quoteWords.answer, 'g'),
                  history.message
                )
                smsContent.parameter.to = smsContent.parameter.to.replace(
                  new RegExp(history.quoteWords.answer, 'g'),
                  history.message
                )
              }
            }
          }

          // ロボ引用がある場合
          if (this.roboArguments) {
            for (const arg of this.roboArguments) {
              smsContent.mainmessage = smsContent.mainmessage.replace(
                new RegExp(arg.key, 'g'),
                arg.value
              )
              smsContent.parameter.to = smsContent.parameter.to.replace(
                new RegExp(arg.key, 'g'),
                arg.value
              )
            }
          }
          // 置換できなかったロボ引用は削除
          smsContent.mainmessage = smsContent.mainmessage.replace(
            new RegExp(/__robo_quote\.([a-z0-9]+|[a-z]+)__/, 'g'),
            ''
          )
          smsContent.parameter.to = smsContent.parameter.to.replace(
            new RegExp(/__robo_quote\.([a-z0-9]+|[a-z]+)__/, 'g'),
            ''
          )

          // 置換しきれなかった代替文字列を削除
          smsContent.mainmessage = smsContent.mainmessage.replace(
            new RegExp(/__(\d+|\d+\.[a-z0-9]+|[a-z]+)__/, 'g'),
            ''
          )
          smsContent.parameter.to = smsContent.parameter.to.replace(
            new RegExp(/__(\d+|\d+\.[a-z0-9]+|[a-z]+)__/, 'g'),
            ''
          )

          // メール内容のエスケープ文字置換
          smsContent.mainmessage = alterReplace(smsContent.mainmessage, true)

          // SMS送信タイミングの判定
          if (smsContent.parameter.after == undefined) {
            // SMS送信
            this.$store.dispatch('chatbot/sendSMSScenario', {
              content: smsContent,
              is_demo: false,
            })
          }
          if (smsContent.parameter.is_same_day === true || smsContent.parameter.after == 0) {
            // SMS送信
            this.$store.dispatch('chatbot/sendSMSScenario', {
              content: smsContent,
              is_demo: false,
            })
          }
          if (smsContent.parameter.after > 0) {
            // SMS遅延送信
            smsContent.parameter.mainmessage = smsContent.mainmessage
            this.$store.dispatch('chatbot/createSendScheduledMessage', {
              sessionid: this.seeker.id,
              status: 1,
              parameter: smsContent.parameter,
              schedule: new Date(moment(new Date()).add('days', smsContent.parameter.after)),
              is_finished: false,
              error_log: null,
            })
          }
        }
        let scenarioName = null
        let nextNode = null
        if (this.scenario.output_flg === true) {
          scenarioName = this.roboPartsSetOutsideScenario
          nextNode = this.roboPartsSetNextNode
        } else {
          scenarioName = this.scenario.name
          nextNode = this.scenario.select[0].next_node
        }
        this.$store.dispatch('chatbot/getScenarioOne', {
          companyid: ckey,
          scenarioName: scenarioName,
          node: nextNode,
          rate: this.color.thinking_rate,
          minipk: this.minipk,
        })
        let tempTid = this.minipk || (this.viewType === 0 ? this.botid : this.targetID)
        localStorage.setItem(
          'scenariolv_' + tempTid,
          JSON.stringify({
            node: nextNode,
            date: Date().toString(),
            isPartsSet: scenarioName == 'parts-set',
            partsSetOutsideNextNode: scenarioName == 'parts-set' ? this.roboPartsSetNextNode : ''
          })
        )
      } else if (this.scenario.status === 19) {
        // 回答出力(19)
        if (!this.isDemo) {
          // 回答出力
          // ファイル名をロボ引用で置換
          let sendParameter = JSON.parse(JSON.stringify(this.scenario.parameter))
          // ロボ引用がある場合は置換する
          if (this.roboArguments) {
            for (const arg of this.roboArguments) {
              sendParameter.file_name = sendParameter.file_name.replace(
                new RegExp(arg.key, 'g'),
                arg.value
              )
            }
          }
          // 置換できなかったロボ引用は削除
          sendParameter.file_name = sendParameter.file_name.replace(
            new RegExp(/__robo_quote\.([a-z0-9]+|[a-z]+)__/, 'g'),
            ''
          )

          let scenarioName = null
          if (this.scenario.name === 'parts-set') {
            scenarioName = this.roboPartsSetOutsideScenario
          } else {
            scenarioName = this.scenario.name
          }
          this.$store.dispatch('chatbot/answerOutput', {
            company_id: ckey,
            bot_id: this.botid ? this.botid : this.widgetData.bots[0].bot_id,
            scenario_name: scenarioName,
            seeker_pk: this.seeker.pk,
            room_pk: this.widgetData.roomPK,
            parameter: sendParameter
          })
        } else {
          this.pushScenario()
        }

        // 次のシナリオに遷移
        let scenarioName = null
        let nextNode = null
        if (this.scenario.output_flg === true) {
          scenarioName = this.roboPartsSetOutsideScenario
          nextNode = this.roboPartsSetNextNode
        } else {
          scenarioName = this.scenario.name
          nextNode = this.scenario.select[0].next_node
        }
        this.$store.dispatch('chatbot/getScenarioOne', {
          companyid: ckey,
          scenarioName: scenarioName,
          node: nextNode,
          rate: this.color.thinking_rate,
          minipk: this.minipk,
        })
        let tempTid = this.minipk || (this.viewType === 0 ? this.botid : this.targetID)
        localStorage.setItem(
          'scenariolv_' + tempTid,
          JSON.stringify({
            node: nextNode,
            date: Date().toString(),
            isPartsSet: scenarioName == 'parts-set',
            partsSetOutsideNextNode: scenarioName == 'parts-set' ? this.roboPartsSetNextNode : ''
          })
        )
      } else if (this.scenario.status === 21) {
        // PDFダウンロード(21)
        let pdfContent = this.scenario

        // シナリオ内に記載された代替文字列を置換
        let lsApplicant = ''
        let lsEmail = ''
        let lsTel = ''
        let lsAddress = ''
        let lsFurigana = ''
        let lsYyyymmdd = ''
        let lsYears = ''
        let lsBikou = ''
        let lsShikaku = ''
        let lsCareer = ''
        let lsScedule = ''
        let lsPoint = ''
        if (this.isDemo) {
          lsApplicant = localStorage.getItem('NM_demo')
          lsEmail = localStorage.getItem('EM_demo')
          lsTel = localStorage.getItem('TL_demo')
          lsAddress = localStorage.getItem('AD_demo')
          lsFurigana = localStorage.getItem('FR_demo')
          lsYyyymmdd = localStorage.getItem('BD_demo')
          lsYears = localStorage.getItem('YE_demo')
          lsBikou = localStorage.getItem('BK_demo')
          lsShikaku = localStorage.getItem('SH_demo')
          lsCareer = localStorage.getItem('GK_demo')
          lsScedule = localStorage.getItem('SC_demo')
          lsPoint = localStorage.getItem('SCR')
        } else {
          lsApplicant = localStorage.getItem('NM_' + this.seeker.id)
          lsEmail = localStorage.getItem('EM_' + this.seeker.id)
          lsTel = localStorage.getItem('TL_' + this.seeker.id)
          lsAddress = localStorage.getItem('AD_' + this.seeker.id)
          lsFurigana = localStorage.getItem('FR_' + this.seeker.id)
          lsYyyymmdd = localStorage.getItem('BD_' + this.seeker.id)
          lsYears = localStorage.getItem('YE_' + this.seeker.id)
          lsBikou = localStorage.getItem('BK_' + this.seeker.id)
          lsShikaku = localStorage.getItem('SH_' + this.seeker.id)
          lsCareer = localStorage.getItem('GK_' + this.seeker.id)
          lsScedule = localStorage.getItem('SC_' + this.seeker.id)
          lsPoint = localStorage.getItem('SCR')
        }

        lsApplicant = lsApplicant === null ? '' : lsApplicant
        lsEmail = lsEmail === null ? '' : lsEmail
        lsTel = lsTel === null ? '' : lsTel
        lsAddress = lsAddress === null ? '' : lsAddress
        lsFurigana = lsFurigana === null ? '' : lsFurigana
        lsYyyymmdd = lsYyyymmdd === null ? '' : lsYyyymmdd
        lsYears = lsYears === null ? '' : lsYears
        lsBikou = lsBikou === null ? '' : lsBikou
        lsShikaku = lsShikaku === null ? '' : lsShikaku
        lsCareer = lsCareer === null ? '' : lsCareer
        lsScedule = lsScedule === null ? '' : lsScedule
        lsPoint = lsPoint === null ? '' : lsPoint

        pdfContent.parameter.item_list = pdfContent.parameter.item_list
          .replace(new RegExp('__applicant__', 'g'), '名前\t' + lsApplicant)
          .replace(new RegExp('__email__', 'g'), 'Email\t' + lsEmail)
          .replace(new RegExp('__tel__', 'g'), 'TEL\t' + lsTel)
          .replace(new RegExp('__address__', 'g'), '住所\t' + lsAddress)
          .replace(new RegExp('__furigana__', 'g'), '名前（ふりがな）\t' + lsFurigana)
          .replace(new RegExp('__yyyymmdd__', 'g'), '生年月日\t' + lsYyyymmdd)
          .replace(new RegExp('__years__', 'g'), '年齢\t' + lsYears)
          .replace(new RegExp('__shikaku__', 'g'), '資格\t' + lsShikaku)
          .replace(new RegExp('__career__', 'g'), '学歴・職歴\t' + lsCareer)
          .replace(new RegExp('__bikou__', 'g'), '備考\t' + lsBikou)
          .replace(new RegExp('__date__', 'g'), '日程\t' + lsScedule)
          .replace(new RegExp('__point__', 'g'), 'ポイント\t' + lsPoint)
        let tempChatTalkHistory = this.chatTalkHistory.slice().reverse()
        for (const history of tempChatTalkHistory) {
          // 会話履歴の応募フォームから置換
          if (history.quoteWords !== undefined && history.speaker === 'my') {
            if (history.status === 1 || history.status === 8) {
              // 応募フォーム or 履歴書フォームのとき
              const replaceName = history.quoteAnswers.name
              const replaceFurigana = history.quoteAnswers.furigana
              const replaceEmail = history.quoteAnswers.email
              const replaceTel = history.quoteAnswers.tel
              let replaceGender = ''
              if (history.quoteAnswers.gender == 0) {
                replaceGender = '未選択'
              } else if (history.quoteAnswers.gender == 1) {
                replaceGender = '男性'
              } else if (history.quoteAnswers.gender == 2) {
                replaceGender = '女性'
              } else if (history.quoteAnswers.gender == 3) {
                replaceGender = '選択しない'
              }
              const replaceAddress = history.quoteAnswers.address
              const replaceBirth = history.quoteAnswers.birth
              const replaceMessage = history.quoteAnswers.msg
              let birth = replaceBirth
              if (birth) {
                if (typeof(birth) === "object") {
                  birth = birth.getFullYear() + '/' + (birth.getMonth() + 1) + '/' + birth.getDate()
                }
            }
              pdfContent.parameter.item_list = pdfContent.parameter.item_list
                .replace(new RegExp(history.quoteWords.name, 'g'), '名前\t' + replaceName)
                .replace(
                  new RegExp(history.quoteWords.furigana, 'g'),
                  'フリガナ（名前）\t' + replaceFurigana
                )
                .replace(new RegExp(history.quoteWords.email, 'g'), 'Email\t' + replaceEmail)
                .replace(new RegExp(history.quoteWords.tel, 'g'), 'TEL\t' + replaceTel)
                .replace(new RegExp(history.quoteWords.gender, 'g'), '性別\t' + replaceGender)
                .replace(new RegExp(history.quoteWords.address, 'g'), '住所\t' + replaceAddress)
                .replace(new RegExp(history.quoteWords.birth, 'g'), '生年月日\t' + birth)
                .replace(new RegExp(history.quoteWords.message, 'g'), '備考\t' + replaceMessage)
            }
            else if (history.status == 15) {
              // プルダウンのとき
              const keys = Object.keys(history.quoteAnswers)
              for (let k of keys) {
                if (history.quoteWords[k] && history.quoteAnswers[k]) {
                  pdfContent.parameter.item_list = pdfContent.parameter.item_list.replace(
                    new RegExp(history.quoteWords[k], 'g'),
                    history.quoteWords[k] + '\t' + history.quoteAnswers[k])
                }
              }
              if (history.quoteWords.answer) {
                pdfContent.parameter.item_list = pdfContent.parameter.item_list.replace(
                  new RegExp(history.quoteWords.answer, 'g'),
                  history.quoteWords.answer + '\t' + history.message)
              }
            }
            else {
              // 応募フォーム以外
              pdfContent.parameter.item_list = pdfContent.parameter.item_list.replace(
                new RegExp(history.quoteWords.answer, 'g'),
                '__' +
                  history.pk +
                  '__' +
                  '\t' +
                  history.message.replace(new RegExp('\n', 'g'), '<br>')
              )
            }
          }
        }
        // PDF項目リストのエスケープ文字置換
        pdfContent.parameter.item_list = alterReplace(pdfContent.parameter.item_list, true)
        let tempTid = this.minipk || (this.viewType === 0 ? this.botid : this.targetID)
        let nextNode = null
        if (this.scenario.output_flg === true) {
          nextNode = this.roboPartsSetNextNode
        } else {
          nextNode = this.scenario.select[0].next_node
        }
        localStorage.setItem(
          'scenariolv_' + tempTid,
          JSON.stringify({
            node: nextNode,
            date: Date().toString(),
            isPartsSet: scenarioName == 'parts-set',
            partsSetOutsideNextNode: scenarioName == 'parts-set' ? this.roboPartsSetNextNode : ''
          })
        )
        let scenarioName = null
        this.pushScenario()
      } else if (this.scenario.status === 100) {
        // パーツセット(100)

        const minirobo_ps = (this.scenario.parameter['minirobos'] || []).find((robo) => robo['pk'] == this.minipk)
        let partsSet = (minirobo_ps ? minirobo_ps['partsset'] : null)
        if (!partsSet) partsSet = this.scenario.robo_parts_set

        this.$store.dispatch('chatbot/getRoboPartsSetInput', partsSet)
          .then((d) => {
            this.$store.dispatch('chatbot/setRoboPartsSetInside', {name: this.scenario.name, node: this.scenario.select[0].next_node})
            // パーツセット内のシナリオへ
            this.$store.dispatch('chatbot/getScenarioOne', {
              companyid: ckey,
              scenarioName: 'parts-set',
              node: d,
              rate: this.color.thinking_rate,
              minipk: this.minipk,
            })
            let tempTid = this.minipk || (this.viewType === 0 ? this.botid : this.targetID)
            localStorage.setItem(
              'scenariolv_' + tempTid,
              JSON.stringify({
                node: d,
                date: Date().toString(),
                isPartsSet: true,
                partsSetOutsideNextNode: this.scenario.select[0].next_node
              })
            )
          })
      } else {
        // 選択肢ありメッセージ(0)
        // 応募フォーム(1)
        // メッセージのみ(2)
        // 画像表示(5)
        // 自由入力(6)
        // ファイルアップロード(7)
        // 履歴書(8)
        // チェック項目(13)
        // 動画(14)
        // プルダウン選択(15)
        // ファイルダウンロード(18)
        // 検索(20)
        this.pushScenario()
        if (
          this.isAutomatic === true &&
          (this.scenario.status === 2 || this.scenario.status === 5 || this.scenario.status === 14)
        ) {
          // 自動進行ONの場合
          // メッセージのみ(2)
          // 画像表示(5)
          // 動画(14)
          let scenarioName = null
          let nextNode = null
          if (this.scenario.output_flg === true) {
            scenarioName = this.roboPartsSetOutsideScenario
            nextNode = this.roboPartsSetNextNode
          } else {
            scenarioName = this.scenario.name
            nextNode = this.scenario.select[0].next_node
          }
          this.$store.dispatch('chatbot/getScenarioOne', {
            companyid: ckey,
            scenarioName: scenarioName,
            node: nextNode,
            rate: this.color.thinking_rate,
            minipk: this.minipk,
          })
          let tempTid = this.minipk || (this.viewType === 0 ? this.botid : this.targetID)
          localStorage.setItem(
            'scenariolv_' + tempTid,
            JSON.stringify({
              node: nextNode,
              date: Date().toString(),
              isPartsSet: scenarioName == 'parts-set',
              partsSetOutsideNextNode: scenarioName == 'parts-set' ? this.roboPartsSetNextNode : ''
            })
          )
        }
      }
      if (!this.isDemo) {
        // デモ以外の時
        // Seekerの既読付与
        this.$store.dispatch('directtalk/setIsRead', 'seeker')
      }
    },
    // scenario end
  },
}
export default watchScenarioMixin



// WEBPACK FOOTER //
// ./src/mixins/watchScenarioMixin.js